import { MaterialIcon } from "@website/icons/material";
import {
  CarouselNavigationButtonPropertiesType,
  CarouselNavigationPropertiesType
} from "@website/ui/carousel/carousel.types";
import { useEffect } from "react";

const SliderButton = ({
  icon,
  onClick,
  disabled,
  classes
}: CarouselNavigationButtonPropertiesType) => (
  <button
    className={`bg-on-surface-high-emphasis z-1 absolute bottom-1/2 size-9 translate-y-1/2 transform-gpu rounded-full px-1.5 py-0.5 opacity-0 transition group-hover:opacity-100 ${classes} ${
      disabled ? "hidden" : ""
    }`}
    disabled={disabled}
    onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    }}
    type="button"
  >
    <MaterialIcon name={icon} />
  </button>
);

const CarouselNavigation = ({
  currentSlide,
  currentReference,
  rightBtnClassName,
  leftBtnClassName,
  hasNavigation,
  disableArrowKeys
}: CarouselNavigationPropertiesType) => {
  useEffect(() => {
    if (!disableArrowKeys) {
      const listener = (event: KeyboardEvent) => {
        if (event.key === "ArrowRight") {
          currentReference?.prev();
        }
        if (event.key === "ArrowLeft") {
          currentReference?.next();
        }
      };
      document.addEventListener("keydown", listener);
      return () => document.removeEventListener("keydown", listener);
    }
  }, [currentReference, disableArrowKeys]);
  return (
    <div
      className={`${
        hasNavigation === "fixed" ? "" : "max-lg:hidden"
      } text-on-color-high-emphasis text-2xl hover:block`}
    >
      <SliderButton
        classes={`${rightBtnClassName} ${
          hasNavigation === "fixed" ? "opacity-100 lg:opacity-0" : ""
        } -right-4`}
        disabled={currentSlide === 0}
        icon="chevron_right"
        onClick={() => currentReference?.prev()}
      />
      <SliderButton
        classes={`${leftBtnClassName} ${
          hasNavigation === "fixed" ? "opacity-100 lg:opacity-0" : ""
        } -left-4`}
        disabled={currentSlide === currentReference?.track?.details?.maxIdx}
        icon="chevron_left"
        onClick={() => currentReference?.next()}
      />
    </div>
  );
};

export default CarouselNavigation;
